import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "services/api";
import { CreateBusiness } from "../auth/types";
import {
  Business,
  BusinessDetails,
  BusinessItemsRequest,
  BusinessListRequest,
  BusinessTypeRequest,
  BusinessTypeResponse,
} from "./types";

export const businessApi = createApi({
  reducerPath: "businessService",
  baseQuery,
  endpoints: (builder) => ({
    getBusinessTypesByIndustryId: builder.query<
      BusinessTypeResponse,
      BusinessTypeRequest
    >({
      query: (businessTypeRequest: BusinessTypeRequest) => ({
        url: `/businessType/${businessTypeRequest.industry_id || ""}`,
        method: "GET",
      }),
    }),
    getBusinessItemsByBusinessTypeId: builder.query<any, BusinessItemsRequest>({
      query: (businessRequestItems: BusinessItemsRequest) => ({
        url: `/business/business/items?businessId=${businessRequestItems.businessType_id}`,
        method: "GET",
      }),
    }),
    getBusinesses: builder.query<any, null>({
      query: () => ({
        url: `/business`,
        method: "GET",
      }),
    }),
    getBusinessesByRegion: builder.query<any, BusinessListRequest>({
      query: (businessListRequest: BusinessListRequest) => ({
        url: `/business/region/${businessListRequest.region_id}/user/${businessListRequest.userid}`,
        method: "GET",
      }),
    }),

    getBusinessListByRegionId: builder.query<any, BusinessListRequest>({
      query: (businessListRequest: BusinessListRequest) => ({
        url: `/business/list/region/${businessListRequest.region_id}/user/${businessListRequest.userid}`,
        method: "GET",
      }),
    }),

    getBusinessesById: builder.query<Business, BusinessDetails>({
      query: (businessDetails: BusinessDetails) => ({
        url: `/business/${businessDetails.id}`,
        method: "GET",
      }),
    }),

    getBusinessesByUserId: builder.query<any, BusinessDetails>({
      query: (businessDetails: BusinessDetails) => ({
        url: `/business/user/${businessDetails.id}`,
        method: "GET",
      }),
    }),

    createBusiness: builder.mutation<any, CreateBusiness>({
      query: (business: CreateBusiness) => ({
        url: `/business`,
        method: "POST",
        body: JSON.stringify(business),
      }),
    }),

    upadateBusiness: builder.mutation<
      any,
      { business_id: number; payload: Partial<CreateBusiness> }
    >({
      query: ({ business_id, payload }) => ({
        url: `/business?id=${business_id}`,
        method: "PUT",
        body: payload,
      }),
    }),

    favoriteBusiness: builder.mutation<
      number,
      { userId: number; businessId: number }
    >({
      query: ({ userId, businessId }) => ({
        url: `/favorites/toggle/user/${userId}/business/${businessId}`,
        method: "POST",
      }),
    }),

    importFareharbor: builder.mutation<any, { id: number; shortname: string }>({
      query: ({ id, shortname }) => ({
        url: `/business/${id}/fareharbor/${shortname}`,
        method: "PUT",
        body: {},
      }),
    }),
  }),
});

export const {
  useGetBusinessTypesByIndustryIdQuery,
  useLazyGetBusinessTypesByIndustryIdQuery,
  useGetBusinessItemsByBusinessTypeIdQuery,
  useLazyGetBusinessesQuery,
  useLazyGetBusinessesByRegionQuery,
  useLazyGetBusinessListByRegionIdQuery,
  useGetBusinessesByIdQuery,
  useGetBusinessesByUserIdQuery,
  useCreateBusinessMutation,
  useUpadateBusinessMutation,
  useFavoriteBusinessMutation,
  useImportFareharborMutation,
} = businessApi;
